import * as React from 'react';
import styled from 'styled-components';
import { storeDispatch } from '../state/Store';
import * as Actions from '../state/actions';
import { hoverMixin } from 'utils/style';

const Wrapper = styled.button`
  position: fixed;
  left: 30px;
  top: calc(30px + var(--top-bar-height));
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 999px;
  ${hoverMixin('background-color: rgba(0, 0, 0, 0.2);')}
  color: var(--primary-text-color);
`;

export class PageBack extends React.Component {
  didClick = () => {
    storeDispatch(Actions.goBack());
  };
  render() {
    return <Wrapper onClick={this.didClick}>‹ Back</Wrapper>;
  }
}



// WEBPACK FOOTER //
// ./src/components/PageBack.tsx